export enum EmployeePermission {

    // User permissions
    VIEW_NOTIFICATIONS = 'VIEW_NOTIFICATIONS',
    CREATE_USER = 'CREATE_USER',
    UPDATE_USER = 'UPDATE_USER',
    DELETE_USER = 'DELETE_USER',
    VIEW_TEAM = 'VIEW_TEAM',

    // Project permissions
    VIEW_PROJECT_DETAILS = 'VIEW_PROJECT_DETAILS',
    CREATE_PROJECT = 'CREATE_PROJECT',
    UPDATE_PROJECT = 'UPDATE_PROJECT',
    DELETE_PROJECT = 'DELETE_PROJECT',
    PRINT_PROJECTS = 'PRINT_PROJECTS',
    CREATE_TASK = 'CREATE_TASK',
    UPDATE_TASK = 'UPDATE_TASK',
    DELETE_TASK = 'DELETE_TASK',
    PROCESS_PROJECT_REQUEST = 'PROCESS_PROJECT_REQUEST',

    // Markout permissions
    VIEW_MARKOUT = 'VIEW_MARKOUT',
    CREATE_MARKOUT = 'CREATE_MARKOUT',
    UPDATE_MARKOUT = 'UPDATE_MARKOUT',
    DELETE_MARKOUT = 'DELETE_MARKOUT',
    PROCESS_MARKOUT_REQUEST = 'PROCESS_MARKOUT_REQUEST',
    DELETE_MARKOUT_REQUEST = 'DELETE_MARKOUT_REQUEST',

    // Incident permissions
    CREATE_INCIDENT = 'CREATE_INCIDENT',
    UPDATE_INCIDENT = 'UPDATE_INCIDENT',
    DELETE_INCIDENT = 'DELETE_INCIDENT',

    // Checklist permissions
    CREATE_CHECKLIST = 'CREATE_CHECKLIST',
    UPDATE_CHECKLIST = 'UPDATE_CHECKLIST',
    DELETE_CHECKLIST = 'DELETE_CHECKLIST',

    // Timesheet permissions
    CREATE_TIMESHEET = 'CREATE_TIMESHEET',
    UPDATE_TIMESHEET = 'UPDATE_TIMESHEET',
    DELETE_TIMESHEET = 'DELETE_TIMESHEET',
    APPROVE_TIMESHEET = 'APPROVE_TIMESHEET',

    // Management permissions
    MANAGE_RESOURCES = 'MANAGE_RESOURCES',
    MANAGE_COMPANY_INFO = 'MANAGE_COMPANY_INFO',
    VIEW_MANAGEMENT = 'VIEW_MANAGEMENT',

    // Financial Analysis permissions
    FINANCIAL_ANALYSIS = 'FINANCIAL_ANALYSIS',

    // Contact permissions
    CREATE_CONTACT = 'CREATE_CONTACT',
    UPDATE_CONTACT = 'UPDATE_CONTACT',
    DELETE_CONTACT = 'DELETE_CONTACT',
    VIEW_CONTACTS = 'VIEW_CONTACTS',

    // Project Management permissions (RFIs, Submittals, Change Orders)
    VIEW_PROJECT_MANAGEMENT = 'VIEW_PROJECT_MANAGEMENT',
    CREATE_PROJECT_MANAGEMENT = 'CREATE_PROJECT_MANAGEMENT',
    UPDATE_PROJECT_MANAGEMENT = 'UPDATE_PROJECT_MANAGEMENT',
    DELETE_PROJECT_MANAGEMENT = 'DELETE_PROJECT_MANAGEMENT',

    // Billing permissions (AIA Payment Applications)
    VIEW_BILLING = 'VIEW_BILLING',
    CREATE_BILLING = 'CREATE_BILLING',
    UPDATE_BILLING = 'UPDATE_BILLING',
    DELETE_BILLING = 'DELETE_BILLING',

    // Garage permissions
    VIEW_GARAGE = 'VIEW_GARAGE',
    CREATE_GARAGE_MAINTENANCE = 'CREATE_GARAGE_MAINTENANCE',
    UPDATE_GARAGE_MAINTENANCE = 'UPDATE_GARAGE_MAINTENANCE',
    DELETE_GARAGE_MAINTENANCE = 'DELETE_GARAGE_MAINTENANCE',
    CREATE_GARAGE_PART = 'CREATE_GARAGE_PART',
    UPDATE_GARAGE_PART = 'UPDATE_GARAGE_PART',
    DELETE_GARAGE_PART = 'DELETE_GARAGE_PART',

    // Yard Ops permissions
    VIEW_YARD_OPS = 'VIEW_YARD_OPS',
    VIEW_INVENTORY = 'VIEW_INVENTORY',
    VIEW_FUEL_LOG = 'VIEW_FUEL_LOG',
    VIEW_DUMP_TICKET = 'VIEW_DUMP_TICKET',
    CREATE_INVENTORY = 'CREATE_INVENTORY',
    UPDATE_INVENTORY = 'UPDATE_INVENTORY',
    DELETE_INVENTORY = 'DELETE_INVENTORY',
    CREATE_FUEL_LOG = 'CREATE_FUEL_LOG',
    UPDATE_FUEL_LOG = 'UPDATE_FUEL_LOG',
    DELETE_FUEL_LOG = 'DELETE_FUEL_LOG',
    CREATE_DUMP_TICKET = 'CREATE_DUMP_TICKET',
    UPDATE_DUMP_TICKET = 'UPDATE_DUMP_TICKET',
    DELETE_DUMP_TICKET = 'DELETE_DUMP_TICKET',

    // New and synced permissions
    VIEW_CHECKLIST = 'VIEW_CHECKLIST',
    VIEW_INCIDENT = 'VIEW_INCIDENT',
    VIEW_TIMESHEET = 'VIEW_TIMESHEET',
    VIEW_FIELD_MEASURE = 'VIEW_FIELD_MEASURE',
    CREATE_FIELD_MEASURE = 'CREATE_FIELD_MEASURE',
    UPDATE_FIELD_MEASURE = 'UPDATE_FIELD_MEASURE',
    DELETE_FIELD_MEASURE = 'DELETE_FIELD_MEASURE',
}

export enum ProjectStatus {
    ACTIVE = 'ACTIVE',
    UPCOMING = 'UPCOMING',
    ON_HOLD = 'ON_HOLD',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    ARCHIVED = 'ARCHIVED',
}

export enum MarkoutStatus {
    ACTIVE = 'ACTIVE',
    PENDING = 'PENDING',
    ARCHIVED = 'ARCHIVED',
}

export enum UtilityDamagedType {
    ELECTRIC = 'ELECTRIC',
    GAS = 'GAS',
    WATER = 'WATER',
    OTHER = 'OTHER'
}

export class ApplicationData {
    public static EmployeePermissions = [

        { 
            group: 'User Management',
            permissions: [
                { id: EmployeePermission.VIEW_NOTIFICATIONS, name: 'View notifications'},
                { id: EmployeePermission.CREATE_USER, name: 'Creating user'},
                { id: EmployeePermission.UPDATE_USER, name: 'Updating user'},
                { id: EmployeePermission.DELETE_USER, name: 'Deleting user'},
                { id: EmployeePermission.VIEW_TEAM, name: 'View team'},
            ],
        },
        {
            group: 'Project Management',
            permissions: [
                { id: EmployeePermission.VIEW_PROJECT_DETAILS, name: 'View project details'}, 
                { id: EmployeePermission.CREATE_PROJECT, name: 'Creating project'}, 
                { id: EmployeePermission.UPDATE_PROJECT, name: 'Updating project'}, 
                { id: EmployeePermission.DELETE_PROJECT, name: 'Deleting project' },
                { id: EmployeePermission.PRINT_PROJECTS, name: 'Printing project list' },
                { id: EmployeePermission.CREATE_TASK, name: 'Creating project tasks'}, 
                { id: EmployeePermission.UPDATE_TASK, name: 'Updating project tasks'}, 
                { id: EmployeePermission.DELETE_TASK, name: 'Deleting project tasks' },
                { id: EmployeePermission.PROCESS_PROJECT_REQUEST, name: 'Process project requests' }
            ]
        },
        {
            group: 'Markout Management',
            permissions: [
                { id: EmployeePermission.VIEW_MARKOUT, name: 'View markouts'}, 
                { id: EmployeePermission.CREATE_MARKOUT, name: 'Creating markout'}, 
                { id: EmployeePermission.UPDATE_MARKOUT, name: 'Updating markout'}, 
                { id: EmployeePermission.DELETE_MARKOUT, name: 'Deleting markout' },
                { id: EmployeePermission.PROCESS_MARKOUT_REQUEST, name: 'Process markout requests' },
                { id: EmployeePermission.DELETE_MARKOUT_REQUEST, name: 'Deleting markout requests' }
            ]
        },
        {
            group: 'Incident Management',
            permissions: [
                { id: EmployeePermission.VIEW_INCIDENT, name: 'View incidents'},
                { id: EmployeePermission.CREATE_INCIDENT, name: 'Reporting incident'}, 
                { id: EmployeePermission.UPDATE_INCIDENT, name: 'Updating incident'}, 
                { id: EmployeePermission.DELETE_INCIDENT, name: 'Deleting incident' }
            ]
        },
        {
            group: 'Checklist Management',
            permissions: [
                { id: EmployeePermission.VIEW_CHECKLIST, name: 'View checklists'},
                { id: EmployeePermission.CREATE_CHECKLIST, name: 'Creating checklists and items'}, 
                { id: EmployeePermission.UPDATE_CHECKLIST, name: 'Updating checklists and items'}, 
                { id: EmployeePermission.DELETE_CHECKLIST, name: 'Deleting checklists and items' }
            ]
        },
        {
            group: 'Timesheet Management',
            permissions: [
                { id: EmployeePermission.VIEW_TIMESHEET, name: 'View timesheets'},
                { id: EmployeePermission.CREATE_TIMESHEET, name: 'Creating timesheet'},
                { id: EmployeePermission.UPDATE_TIMESHEET, name: 'Updating timesheet'},
                { id: EmployeePermission.DELETE_TIMESHEET, name: 'Deleting timesheet'},
                { id: EmployeePermission.APPROVE_TIMESHEET, name: 'Approving timesheet'}
            ]
        },
        {
            group: 'Management',
            permissions: [
                { id: EmployeePermission.VIEW_MANAGEMENT, name: 'View management'},
                { id: EmployeePermission.MANAGE_RESOURCES, name: 'Manage resources'},
                { id: EmployeePermission.MANAGE_COMPANY_INFO, name: 'Manage company info'}
            ]
        },
        {
            group: 'Financial Analysis',
            permissions: [
                { id: EmployeePermission.FINANCIAL_ANALYSIS, name: 'Access financial analysis'}
            ]
        },
        {
            group: 'Contact Management',
            permissions: [
                { id: EmployeePermission.VIEW_CONTACTS, name: 'View contacts'},
                { id: EmployeePermission.CREATE_CONTACT, name: 'Creating contact'},
                { id: EmployeePermission.UPDATE_CONTACT, name: 'Updating contact'},
                { id: EmployeePermission.DELETE_CONTACT, name: 'Deleting contact'}
            ]
        },
        {
            group: 'Billing (AIA)',
            permissions: [
                { id: EmployeePermission.VIEW_BILLING, name: 'View billing'},
                { id: EmployeePermission.CREATE_BILLING, name: 'Creating payment application'},
                { id: EmployeePermission.UPDATE_BILLING, name: 'Updating payment application'},
                { id: EmployeePermission.DELETE_BILLING, name: 'Deleting payment application'}
            ]
        },
        {
            group: 'Project Management (RFIs/Submittals/CO)',
            permissions: [
                { id: EmployeePermission.VIEW_PROJECT_MANAGEMENT, name: 'View RFIs, Submittals, Change Orders'},
                { id: EmployeePermission.CREATE_PROJECT_MANAGEMENT, name: 'Creating RFIs, Submittals, Change Orders'},
                { id: EmployeePermission.UPDATE_PROJECT_MANAGEMENT, name: 'Updating RFIs, Submittals, Change Orders'},
                { id: EmployeePermission.DELETE_PROJECT_MANAGEMENT, name: 'Deleting RFIs, Submittals, Change Orders'}
            ]
        },
        {
            group: 'Mechanics Garage',
            permissions: [
                { id: EmployeePermission.VIEW_GARAGE, name: 'View garage & fleet list' },
                { id: EmployeePermission.CREATE_GARAGE_MAINTENANCE, name: 'Log maintenance & repairs' },
                { id: EmployeePermission.UPDATE_GARAGE_MAINTENANCE, name: 'Update maintenance logs' },
                { id: EmployeePermission.DELETE_GARAGE_MAINTENANCE, name: 'Delete maintenance logs' },
                { id: EmployeePermission.CREATE_GARAGE_PART, name: 'Add new parts inventory' },
                { id: EmployeePermission.UPDATE_GARAGE_PART, name: 'Update parts inventory' },
                { id: EmployeePermission.DELETE_GARAGE_PART, name: 'Delete parts inventory' },
            ]
        },
        {
            group: 'Yard Operations',
            permissions: [
                { id: EmployeePermission.VIEW_YARD_OPS, name: 'View yard dashboard' },
                { id: EmployeePermission.VIEW_INVENTORY, name: 'View yard inventory' },
                { id: EmployeePermission.VIEW_FUEL_LOG, name: 'View fuel logs' },
                { id: EmployeePermission.VIEW_DUMP_TICKET, name: 'View dump tickets' },
                { id: EmployeePermission.CREATE_INVENTORY, name: 'Add yard inventory items' },
                { id: EmployeePermission.UPDATE_INVENTORY, name: 'Update yard inventory' },
                { id: EmployeePermission.DELETE_INVENTORY, name: 'Delete yard inventory' },
                { id: EmployeePermission.CREATE_FUEL_LOG, name: 'Log fuel transactions' },
                { id: EmployeePermission.UPDATE_FUEL_LOG, name: 'Update fuel logs' },
                { id: EmployeePermission.DELETE_FUEL_LOG, name: 'Delete fuel logs' },
                { id: EmployeePermission.CREATE_DUMP_TICKET, name: 'Log dump tickets' },
                { id: EmployeePermission.UPDATE_DUMP_TICKET, name: 'Update dump tickets' },
                { id: EmployeePermission.DELETE_DUMP_TICKET, name: 'Delete dump tickets' },
            ]
        },
        {
            group: 'Field Measures',
            permissions: [
                { id: EmployeePermission.VIEW_FIELD_MEASURE, name: 'View field measures' },
                { id: EmployeePermission.CREATE_FIELD_MEASURE, name: 'Creating field measure' },
                { id: EmployeePermission.UPDATE_FIELD_MEASURE, name: 'Updating field measure' },
                { id: EmployeePermission.DELETE_FIELD_MEASURE, name: 'Deleting field measure' }
            ]
        }
    ];

    public static PermissionPresets: { name: string; description: string; permissions: string[] }[] = [
        {
            name: 'Admin',
            description: 'Full office access — admin, financials, billing, contacts, team',
            permissions: [
                EmployeePermission.VIEW_NOTIFICATIONS,
                EmployeePermission.CREATE_USER, EmployeePermission.UPDATE_USER, EmployeePermission.DELETE_USER, EmployeePermission.VIEW_TEAM,
                EmployeePermission.VIEW_PROJECT_DETAILS, EmployeePermission.CREATE_PROJECT, EmployeePermission.UPDATE_PROJECT, EmployeePermission.DELETE_PROJECT, EmployeePermission.PRINT_PROJECTS, EmployeePermission.CREATE_TASK, EmployeePermission.UPDATE_TASK, EmployeePermission.DELETE_TASK, EmployeePermission.PROCESS_PROJECT_REQUEST,
                EmployeePermission.VIEW_MARKOUT, EmployeePermission.CREATE_MARKOUT, EmployeePermission.UPDATE_MARKOUT, EmployeePermission.DELETE_MARKOUT, EmployeePermission.PROCESS_MARKOUT_REQUEST, EmployeePermission.DELETE_MARKOUT_REQUEST,
                EmployeePermission.VIEW_TIMESHEET, EmployeePermission.CREATE_TIMESHEET, EmployeePermission.UPDATE_TIMESHEET, EmployeePermission.DELETE_TIMESHEET, EmployeePermission.APPROVE_TIMESHEET,
                EmployeePermission.VIEW_CHECKLIST, EmployeePermission.CREATE_CHECKLIST, EmployeePermission.UPDATE_CHECKLIST, EmployeePermission.DELETE_CHECKLIST,
                EmployeePermission.VIEW_INCIDENT, EmployeePermission.CREATE_INCIDENT, EmployeePermission.UPDATE_INCIDENT, EmployeePermission.DELETE_INCIDENT,
                EmployeePermission.VIEW_MANAGEMENT, EmployeePermission.MANAGE_RESOURCES,
                EmployeePermission.FINANCIAL_ANALYSIS,
                EmployeePermission.VIEW_CONTACTS, EmployeePermission.CREATE_CONTACT, EmployeePermission.UPDATE_CONTACT, EmployeePermission.DELETE_CONTACT,
                EmployeePermission.VIEW_BILLING, EmployeePermission.CREATE_BILLING, EmployeePermission.UPDATE_BILLING, EmployeePermission.DELETE_BILLING,
                EmployeePermission.VIEW_PROJECT_MANAGEMENT, EmployeePermission.CREATE_PROJECT_MANAGEMENT, EmployeePermission.UPDATE_PROJECT_MANAGEMENT, EmployeePermission.DELETE_PROJECT_MANAGEMENT,
                EmployeePermission.VIEW_FIELD_MEASURE, EmployeePermission.CREATE_FIELD_MEASURE, EmployeePermission.UPDATE_FIELD_MEASURE, EmployeePermission.DELETE_FIELD_MEASURE,
            ]
        },
        {
            name: 'Project Manager',
            description: 'Projects, RFIs, submittals, change orders, billing, contacts',
            permissions: [
                EmployeePermission.VIEW_NOTIFICATIONS,
                EmployeePermission.VIEW_PROJECT_DETAILS, EmployeePermission.CREATE_PROJECT, EmployeePermission.UPDATE_PROJECT, EmployeePermission.DELETE_PROJECT, EmployeePermission.PRINT_PROJECTS, EmployeePermission.CREATE_TASK, EmployeePermission.UPDATE_TASK, EmployeePermission.DELETE_TASK,
                EmployeePermission.VIEW_MARKOUT, EmployeePermission.CREATE_MARKOUT, EmployeePermission.UPDATE_MARKOUT, EmployeePermission.DELETE_MARKOUT, EmployeePermission.DELETE_MARKOUT_REQUEST,
                EmployeePermission.VIEW_TIMESHEET, EmployeePermission.CREATE_TIMESHEET, EmployeePermission.UPDATE_TIMESHEET, EmployeePermission.APPROVE_TIMESHEET,
                EmployeePermission.VIEW_CHECKLIST, EmployeePermission.CREATE_CHECKLIST, EmployeePermission.UPDATE_CHECKLIST, EmployeePermission.DELETE_CHECKLIST,
                EmployeePermission.VIEW_INCIDENT, EmployeePermission.CREATE_INCIDENT, EmployeePermission.UPDATE_INCIDENT, EmployeePermission.DELETE_INCIDENT,
                EmployeePermission.VIEW_TEAM,
                EmployeePermission.VIEW_CONTACTS, EmployeePermission.CREATE_CONTACT, EmployeePermission.UPDATE_CONTACT,
                EmployeePermission.VIEW_BILLING, EmployeePermission.CREATE_BILLING, EmployeePermission.UPDATE_BILLING,
                EmployeePermission.VIEW_PROJECT_MANAGEMENT, EmployeePermission.CREATE_PROJECT_MANAGEMENT, EmployeePermission.UPDATE_PROJECT_MANAGEMENT, EmployeePermission.DELETE_PROJECT_MANAGEMENT,
                EmployeePermission.FINANCIAL_ANALYSIS,
                EmployeePermission.VIEW_FIELD_MEASURE, EmployeePermission.CREATE_FIELD_MEASURE, EmployeePermission.UPDATE_FIELD_MEASURE, EmployeePermission.DELETE_FIELD_MEASURE,
            ]
        },
        {
            name: 'Foreman',
            description: 'Field supervisor — projects, markouts, timesheets, checklists, incidents',
            permissions: [
                EmployeePermission.VIEW_NOTIFICATIONS,
                EmployeePermission.VIEW_PROJECT_DETAILS, EmployeePermission.CREATE_PROJECT, EmployeePermission.UPDATE_PROJECT, EmployeePermission.CREATE_TASK, EmployeePermission.UPDATE_TASK,
                EmployeePermission.VIEW_MARKOUT, EmployeePermission.CREATE_MARKOUT, EmployeePermission.UPDATE_MARKOUT,
                EmployeePermission.VIEW_TIMESHEET, EmployeePermission.CREATE_TIMESHEET, EmployeePermission.UPDATE_TIMESHEET, EmployeePermission.APPROVE_TIMESHEET,
                EmployeePermission.VIEW_CHECKLIST, EmployeePermission.CREATE_CHECKLIST, EmployeePermission.UPDATE_CHECKLIST,
                EmployeePermission.VIEW_INCIDENT, EmployeePermission.CREATE_INCIDENT, EmployeePermission.UPDATE_INCIDENT,
                EmployeePermission.VIEW_TEAM,
                EmployeePermission.VIEW_FIELD_MEASURE, EmployeePermission.CREATE_FIELD_MEASURE, EmployeePermission.UPDATE_FIELD_MEASURE,
            ]
        },
        {
            name: 'Superintendent',
            description: 'Senior field oversight — projects, markouts, timesheets, checklists, incidents, team',
            permissions: [
                EmployeePermission.VIEW_NOTIFICATIONS,
                EmployeePermission.VIEW_PROJECT_DETAILS, EmployeePermission.CREATE_PROJECT, EmployeePermission.UPDATE_PROJECT, EmployeePermission.DELETE_PROJECT, EmployeePermission.PRINT_PROJECTS, EmployeePermission.CREATE_TASK, EmployeePermission.UPDATE_TASK, EmployeePermission.DELETE_TASK,
                EmployeePermission.VIEW_MARKOUT, EmployeePermission.CREATE_MARKOUT, EmployeePermission.UPDATE_MARKOUT, EmployeePermission.DELETE_MARKOUT, EmployeePermission.PROCESS_MARKOUT_REQUEST, EmployeePermission.DELETE_MARKOUT_REQUEST,
                EmployeePermission.VIEW_TIMESHEET, EmployeePermission.CREATE_TIMESHEET, EmployeePermission.UPDATE_TIMESHEET, EmployeePermission.DELETE_TIMESHEET, EmployeePermission.APPROVE_TIMESHEET,
                EmployeePermission.VIEW_CHECKLIST, EmployeePermission.CREATE_CHECKLIST, EmployeePermission.UPDATE_CHECKLIST, EmployeePermission.DELETE_CHECKLIST,
                EmployeePermission.VIEW_INCIDENT, EmployeePermission.CREATE_INCIDENT, EmployeePermission.UPDATE_INCIDENT, EmployeePermission.DELETE_INCIDENT,
                EmployeePermission.VIEW_TEAM,
                EmployeePermission.VIEW_FIELD_MEASURE, EmployeePermission.CREATE_FIELD_MEASURE, EmployeePermission.UPDATE_FIELD_MEASURE, EmployeePermission.DELETE_FIELD_MEASURE,
            ]
        },
        {
            name: 'Office Manager',
            description: 'Office access — billing, contacts, financials, team management',
            permissions: [
                EmployeePermission.VIEW_NOTIFICATIONS,
                EmployeePermission.CREATE_USER, EmployeePermission.UPDATE_USER, EmployeePermission.DELETE_USER, EmployeePermission.VIEW_TEAM,
                EmployeePermission.VIEW_CONTACTS, EmployeePermission.CREATE_CONTACT, EmployeePermission.UPDATE_CONTACT, EmployeePermission.DELETE_CONTACT,
                EmployeePermission.VIEW_BILLING, EmployeePermission.CREATE_BILLING, EmployeePermission.UPDATE_BILLING, EmployeePermission.DELETE_BILLING,
                EmployeePermission.VIEW_PROJECT_MANAGEMENT, EmployeePermission.CREATE_PROJECT_MANAGEMENT, EmployeePermission.UPDATE_PROJECT_MANAGEMENT, EmployeePermission.DELETE_PROJECT_MANAGEMENT,
                EmployeePermission.FINANCIAL_ANALYSIS,
                EmployeePermission.PRINT_PROJECTS,
            ]
        },
        {
            name: 'Owner',
            description: 'Full access — all permissions enabled',
            permissions: Object.values(EmployeePermission)
        },
        {
            name: 'Mechanic',
            description: 'Garage access — fleet maintenance, repairs, and parts inventory',
            permissions: [
                EmployeePermission.VIEW_TEAM,
                EmployeePermission.VIEW_GARAGE,
                EmployeePermission.CREATE_GARAGE_MAINTENANCE,
                EmployeePermission.UPDATE_GARAGE_MAINTENANCE,
                EmployeePermission.DELETE_GARAGE_MAINTENANCE,
                EmployeePermission.CREATE_GARAGE_PART,
                EmployeePermission.UPDATE_GARAGE_PART,
                EmployeePermission.DELETE_GARAGE_PART,
            ]
        },
        {
            name: 'Yard',
            description: 'Yard operations — inventory, fuel logging, and dump tickets',
            permissions: [
                EmployeePermission.VIEW_TEAM,
                EmployeePermission.VIEW_YARD_OPS,
                EmployeePermission.VIEW_INVENTORY,
                EmployeePermission.VIEW_FUEL_LOG,
                EmployeePermission.VIEW_DUMP_TICKET,
                EmployeePermission.CREATE_INVENTORY,
                EmployeePermission.UPDATE_INVENTORY,
                EmployeePermission.DELETE_INVENTORY,
                EmployeePermission.CREATE_FUEL_LOG,
                EmployeePermission.UPDATE_FUEL_LOG,
                EmployeePermission.DELETE_FUEL_LOG,
                EmployeePermission.CREATE_DUMP_TICKET,
                EmployeePermission.UPDATE_DUMP_TICKET,
                EmployeePermission.DELETE_DUMP_TICKET,
            ]
        }
    ];
}